import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  StyledCourseHero,
  Overlay,
  TitleBlock,
  Overtitle,
  BadgeCtaBlock,
  BadgeContainer,
  ButtonContainer,
  Shadow,
} from './style';
import { CTA, Text, Badge } from '../../../../ui/atoms';
import { Container } from '../../../../ui/gridSystem';
import { withMediaQueries } from '../../../hoc/withMediaQueries';
import { timestampToDate } from '../../../../utils/common';
import { ModalDownloadReportId } from '../../../../ui/atoms/Modals/ModalDownloadReport';
import { MODAL_OPEN } from '../../../redux/actions';

const CourseStatsHero = ({ data, mediaIsPhone, modalOpen }) => {
  return (
    <StyledCourseHero cover={data?.cover}>
      <Shadow>
        <Container className="pt-0">
          <Overlay>
            <TitleBlock>
              <Badge type="white">{data?.code}</Badge>
              <Overtitle>
                {data?.categories?.map((item, index) => (
                  <span key={`item-${index}`}>{item.label}</span>
                ))}
              </Overtitle>
              <Text type="h1" className="course-title">
                {data?.title}
              </Text>
            </TitleBlock>
            <div>
              <BadgeCtaBlock>
                <BadgeContainer>
                  <Text type="b3">
                    {data?.typology === 'event' ? 'Evento' : 'Corso'}
                  </Text>
                  <Text type="b3">Assegnazioni:&nbsp;{data?.assignments}</Text>
                  <Text type="b3">Fruizioni:&nbsp;{data?.fruitions}</Text>
                  <Text type="b3">Completamenti:&nbsp;{data?.completions}</Text>
                  {data?.created && (
                    <Text type="b3">
                      Data di creazione:&nbsp;
                      {timestampToDate(data?.created)}
                    </Text>
                  )}
                </BadgeContainer>
                <ButtonContainer>
                  <CTA
                    type="tertiary"
                    btnText="Download PERCORSO FORMATIVO"
                    fullsize={mediaIsPhone}
                    icon="download-01"
                    onClick={() => modalOpen(ModalDownloadReportId)}
                  />
                </ButtonContainer>
              </BadgeCtaBlock>
            </div>
          </Overlay>
        </Container>
      </Shadow>
    </StyledCourseHero>
  );
};

CourseStatsHero.propTypes = {
  data: PropTypes.object,
  mediaIsPhone: PropTypes.bool,
  modalOpen: PropTypes.func,
};

export default connect(
  (state) => {
    const data = state.statistics.course;
    return {
      data,
    };
  },
  (dispatch) => ({
    modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
  })
)(withMediaQueries(CourseStatsHero));
